export * from "./HallowLogoText";
